var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteShopify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.717,
    height: 33.442,
    viewBox: "0 0 29.717 33.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-shopify",
    "data-name": "Icon simple-shopify",
    d: "M20.255,31.219l9.395-2.032S26.259,6.256,26.232,6.1a.288.288,0,0,0-.275-.25c-.126,0-2.511-.177-2.511-.177s-1.66-1.659-1.873-1.837a.5.5,0,0,0-.158-.1l-1.19,27.476h.03Zm-4.722-16.5a5.559,5.559,0,0,0-2.31-.552c-1.884,0-1.958,1.18-1.958,1.486,0,1.6,4.218,2.233,4.218,6.027,0,2.988-1.875,4.9-4.434,4.9A6.106,6.106,0,0,1,6.44,24.667l.841-2.716a5.907,5.907,0,0,0,2.968,1.388,1.229,1.229,0,0,0,1.269-1.213c0-2.108-3.455-2.205-3.455-5.675-.044-2.912,2.045-5.749,6.284-5.749a5.186,5.186,0,0,1,2.441.47l-1.23,3.535-.026.013Zm-.7-13.638a.874.874,0,0,1,.527.176c-1.281.605-2.687,2.134-3.265,5.2-.854.277-1.683.527-2.459.753.676-2.324,2.308-6.113,5.2-6.113ZM16.437,4.92V5.1c-.982.3-2.061.63-3.117.958.607-2.314,1.735-3.444,2.715-3.868A7.66,7.66,0,0,1,16.437,4.92Zm.7-2.909c.9.1,1.486,1.129,1.86,2.285-.454.148-.957.3-1.508.477V4.445a7.4,7.4,0,0,0-.353-2.436Zm3.9,1.678c-.026,0-.078.027-.1.027s-.376.1-.93.273C19.453,2.385,18.472.9,16.738.9h-.15A2.142,2.142,0,0,0,14.953,0C10.909,0,8.977,5.048,8.372,7.611c-1.555.475-2.686.828-2.812.878-.879.277-.9.3-1.005,1.133-.1.6-2.383,18.309-2.383,18.309l17.656,3.316L21.035,3.69Z",
    transform: "translate(-1.059 1)",
    fill: "none",
    stroke: "#fcfcfc",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShopify);
export default __webpack_public_path__ + "static/media/WhiteShopify.bc00f47f0b62e899867a2930a4ba638d.svg";
export { ForwardRef as ReactComponent };